export const convertObjectToArray = (data) => {
  const { cards, percentages } = data;
  const result = [];
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const key in cards) {
    result.push({ name: key, count: cards[key] });
  }
  return { result, percentages };
};
